'use strict';

var didWeb = require('./did-web');
var lib = require('./lib');
var types = require('./lib/types');



Object.keys(didWeb).forEach(function (k) {
	if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return didWeb[k]; }
	});
});
Object.keys(lib).forEach(function (k) {
	if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return lib[k]; }
	});
});
Object.keys(types).forEach(function (k) {
	if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return types[k]; }
	});
});
